


































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import {RoleData} from '@/views/administration/roles/interfaces';
import {UserData, UserRole} from '@/views/administration/users/interfaces';
import roleStoreModule from '@/store/modules/entities/roleModule';

@Component({
  components: {EditDialog, SelectionList},
})
export default class UserEditDialog extends Mixins(EditDialogMixin) {
  showPassword = false;

  errorKeyList = {
    login: 'login',
    name: 'name',
    email: 'email',
    password: 'password',
    position: 'position',
    phone: 'phone',
  };

  //Идентификаторы выбранных ролей
  selectedRoleIds: string[] = [];

  //Признак, что нужно сменить пароль
  needChangePassword = false;

  @Watch('selectedRoleIds')
  async onSelectedRoleIds(newVal: any[]) {
    this.data.roles = this.data.roles.map((role: any) => {
      role.bind = newVal.includes(role.roleId);
      return role;
    });
  }

  @Watch('data')
  onLoadData(newVal: UserData | null, oldVal: UserData | null) {
    if (newVal && oldVal === null) {
      const bindRoles = this.data.roles.filter((role: UserRole) => role.bind);
      this.selectedRoleIds = bindRoles.map((role: UserRole) => role.roleId);
    }
  }

  @Watch('needChangePassword')
  onChangedCheckbox(newVal: boolean) {
    if (!newVal) {
      this.data.password = undefined;
    }
  }

  get roleList(): RoleData[] {
    return [...(roleStoreModule.all as RoleData[])];
  }

  @Watch('dialog')
  async onDialog(value: boolean) {
    if (value) await roleStoreModule.fetchAll();
  }

  // поле необязательное, поэтому к регулярке добавляем !v
  get emailRules() {
    return [
      (v: any) =>
        !v ||
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) ||
        'Неправильный адрес электронной почты',
    ];
  }
}
